// admin/SubscriberListPage.js
import React, { useEffect, useState } from 'react';
import { Table, Button, message } from 'antd';
import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_BASE_URL;

const SubscriberListPage = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/subscribers`); // Abone listesini almak için API çağrısı
        setSubscribers(response.data); // Abone verilerini state'e kaydet
      } catch (error) {
        message.error('Abone listesi alınırken bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscribers();
  }, []);

  const handleDelete = async (email) => {
    try {
      await axios.delete(`${apiUrl}/api/subscribers/${email}`); // API üzerinden abone silme işlemi
      setSubscribers(subscribers.filter(subscriber => subscriber.email !== email));
      message.success('Abone başarıyla silindi.');
    } catch (error) {
      message.error('Abone silinirken bir hata oluştu.');
    }
  };

  const columns = [
    {
      title: 'E-posta',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'İşlemler',
      key: 'action',
      render: (_, record) => (
        <Button type="danger" onClick={() => handleDelete(record.email)}>
          Sil
        </Button>
      ),
    },
  ];

  return (
    <div>
      <h1>Abone Listesi</h1>
      <Table
        dataSource={subscribers}
        columns={columns}
        loading={loading}
        rowKey="email"
      />
    </div>
  );
};

export default SubscriberListPage;
